import { useTranslation } from 'react-i18next';
import { BreadcrumbButtonLink } from '~/components/breadcrumbs/styles';

// A component rather than an inline element, because the routes are built at module scope
// where hooks — and so translation — are not available.
export const AnnouncementsBreadcrumb = () => {
  const { t } = useTranslation();

  return (
    <BreadcrumbButtonLink to=".." relative="path">
      {t('components.announcements.title')}
    </BreadcrumbButtonLink>
  );
};
